<script>
    import axios from "axios";

    import NavigationPlatform from "../../components/Navigation/NavigationPlatform.svelte";

    import Discover from "../../routes/Platform/Discover.svelte";
    import Matches from "../../routes/Platform/Matches.svelte";
    import Idea from "../../routes/Platform/Idea.svelte";
    import Profile from "../../routes/Platform/Profile.svelte";

    axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
    axios.defaults.xsrfCookieName = "csrf_access_token";

    export let user;
    let page = Profile;
    let selected = "profile";

    const switchTab = (tab) => {
        switch (tab) {
            case "discover":
                page = Discover;
                break;
            case "pitch":
                page = Idea;
                selected = "idea";
                break;
            case "matches":
                page = Matches;
                break;
            case "profile":
                page = Profile;
                selected = "profile";
                break;
        }
    };
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .profile {
        &-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: var(--spacer-large);

            p {
                margin-bottom: var(--spacer-small);
            }

            h1 {
                font-size: var(--font-large);
                font-weight: var(--weight-regular);
            }

            img {
                width: 125px;
                border-radius: 50%;
                margin-bottom: var(--spacer-small);
            }
        }
    }
</style>

<div class="proflile">
    <div class="profile-header">
        <img alt="user profile" src={user.avatar} />
        {#if !user.confirmed}
            <p>Please confirm your email address</p>
        {/if}
        {#if user.first_name}
            <h1>Welcome {user.first_name}!</h1>
        {:else}
            <h1>Welcome!</h1>
        {/if}
    </div>

    <NavigationPlatform {selected} onClick={switchTab} />

    <svelte:component this={page} {user} />
</div>
